export const DEAL_CAPITALIZATION_GROUP_DEBT: string = 'debt';
export const DEAL_CAPITALIZATION_GROUP_EQUITY: string = 'equity';
export const DEAL_CAPITALIZATION_GROUP_COSTS: string = 'costs';
